/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import _ from "underscore";
import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import browser from "web/script/utils/browser";
import form from "web/script/dom/forms";
import globals from "web/script/modules/globals";
import rothko from "web/script/modules/rothko";
import store from "web/redux/store";
import template from "templates/modules/quick_filters_card";
import url from "web/script/utils/url";
import {addVisibilityWatcher} from "web/script/modules/run-loop";
import { openSidebar } from "web/redux/ducks/feed-sidebar";
import { setActiveFilters } from "web/redux/ducks/feed-filters";
const componentName = "quick-filters-card";
const buttonDisabledClassName = `${componentName}__navigation--disabled`;

const FILTER_SELECTOR = `.${componentName}__filter`;
const REFINE_SELECTOR = `.${componentName}__refine-products`;
const FILTER_BLOCK_ACTIVE_SELECTOR = `.${componentName}__filter-block--active`;
const NEXT_SELECTOR = `.${componentName}__navigation--next`;
const PREVIOUS_SELECTOR = `.${componentName}__navigation--previous`;
const FILTER_ITEMS_SELECTOR = `.${componentName}__filters-list`;
const FILTER_ACTIVE_STATE = `${componentName}__filter--active`;
const FILTER_SCROLL_AMOUNT = 500;

export default baustein.register(componentName, {
    defaultOptions: {
        lazyLoad: false,
        queryString: null,
        feedUrl: null,
        dependentFilters: {},
        options: []
    },

    template,
    currentlyScrolling: false,
    selectedFiltersOrder: 0,
    init() {
        this.selectedFilters = new Map();
        this.client = new rothko.Rothko("modules/quick_filters_card");
        this.client.on("data", this._onGetData.bind(this));
        this._showOrHideFilterNavigation();
        this._scrollSelectedFilters();
        // Add initial selected options to selectedFilters Map.
        this.options.options
            .filter(option => option.checked === true)
            .forEach(this._addOptionToSelectedFilters.bind(this));

        if (!browser.supportSticky) {
            // if browser does not support 'position: sticky' use old buttons

            const oldFilter = this.el.querySelector(".quick-filters-card__refine-products");
            if (oldFilter) {
                oldFilter.classList.remove("hidden");
            }
        }
    },

    onInsert() {
        this._removeVisiblityWatcher = addVisibilityWatcher(this.el, visible => {
            if (visible) {
                this._removeVisiblityWatcher();
                this._fetchRenderData();
            }
        });
    },

    onRemove() {
        if (this._removeVisiblityWatcher) {
            this._removeVisiblityWatcher();
        }
    },

    setupEvents(add) {
        add("click", FILTER_SELECTOR, this.onFilterClick);
        add("click", REFINE_SELECTOR, this.onRefineProductsClick);
        add("click", NEXT_SELECTOR, this.onNextFilterClick);
        add("click", PREVIOUS_SELECTOR, this.onPreviousFilterClick);
        add("scroll", FILTER_ITEMS_SELECTOR, this.onFilterItemScroll);
        add("submit", e => e.preventDefault());
    },

    onOptionsChange() {
        this.options.lazyLoad = true;
        this._fetchRenderData();
    },

    /**
     * Fetches the render context using rothko and updates it. Returns a promise that will be
     * resolved when the render context has been updated.
     * @returns {Promise}
     * @private
     */
    _fetchRenderData() {
        if (!this.options.lazyLoad) {
            this.options.lazyLoad = true;
            return Promise.resolve();
        }
        let query = new url.URLSearchParams(this.options.queryString);
        query.set("feed_url", this.options.feedUrl);
        return this.client.fetch(query);
    },

    _onGetData(event, data) {
        this.updateOptions(
            Object.assign(this.options, {
                options: data.options,
                dependentFilters: data.dependent_filters
            })
        );
        // Add a filter to the selected list if it is checked but not in selected filters - EG it came from universal filters.
        data.options
            .filter(option => option.checked === true && !this._isOptionInSelectedFilters(option))
            .forEach(this._addOptionToSelectedFilters.bind(this));

        // Only order the selected options
        let selectedFilters = this._orderFiltersBySelectionOrder(
            data.options.filter(option => option.checked === true)
        );
        // Appened the unchecked filters to maintain the server order when filters unselected
        let allFilters = selectedFilters.concat(
            data.options.filter(option => option.checked === false)
        );
        let renderContext = {
            quick_filters_card: Object.assign(data, { options: allFilters })
        };
        this.setRenderContext(renderContext);
        this._scrollSelectedFilters();
        this._showOrHideFilterNavigation();
        this.emit("onQuickFiltersGetData", data);
    },

    onRefineProductsClick() {
        this.emit("openFilters");
        store.dispatch(openSidebar());
    },

    /**
     * Remove "dependent" filters, e.g. for category, remove subcategory
     */
    _removeDependentFilters(removedFilter, currentFilters) {
        const descendents = this.options.dependentFilters[removedFilter] || [];

        for (let descendent of descendents) {
            delete currentFilters[descendent];
        }
    },

    _removeFilterKey(filterName, filterValue, filters) {
        let filterData = filters[filterName];
        if (Array.isArray(filterData) && filterData.length > 1) {
            var cleanedFilterArray = _.filter(filterData, value => {
                return value !== filterValue;
            });
            if (cleanedFilterArray.length === 1) {
                filters[filterName] = cleanedFilterArray[0];
            } else {
                filters[filterName] = cleanedFilterArray;
            }
        } else if (filterValue === filterData) {
            delete filters[filterName];
        }
        return filters;
    },

    _clearDuplicates(filterArray) {
        return Array.from(new Set(filterArray));
    },

    _getFilters(formEl) {
        let filters = form.serialize(formEl);
        if ("filter_keyword" in filters) {
            if (Array.isArray(filters["filter_keyword"])) {
                let cleanedFilterKeys = this._clearDuplicates(filters["filter_keyword"]);
                filters["filter_keyword"] = cleanedFilterKeys;
            }
        }
        return filters;
    },

    _scrollSelectedFilters() {
        // Get width of the active block and set scroll to on this...
        const activeFilters = this.el.querySelector(FILTER_BLOCK_ACTIVE_SELECTOR);
        const allFilters = this.el.querySelector(FILTER_ITEMS_SELECTOR);
        const lastActiveFilter = activeFilters.querySelector(`.${FILTER_ACTIVE_STATE}:last-child`);
        const previousButton = this.el.querySelector(PREVIOUS_SELECTOR);
        // Minus an offset to leave more of selected filters peaking
        if (lastActiveFilter) {
            const scrollBy =
                activeFilters.offsetWidth -
                lastActiveFilter.offsetWidth -
                previousButton.offsetWidth -
                15;
            allFilters.scrollLeft = scrollBy;
        }
    },
    _findAndUpdateSelectedFilters(filterName, filterValue) {
        this._addToSelectedFilters(filterName, filterValue);
    },

    /**
     * Every time the user clicks on a filter, compute its active state and apply the new filters
     *
     * @param  {Object}       e       {Object}        Baustein's wrapper around native DOM event object.
     * @param  {HTMLElement}  target  {HTMLElement}   The target of the event, a filter list filter.
     */
    onFilterClick(e, target) {
        const filterInputEl = target.querySelector("input");
        const shouldBeActive = filterInputEl.checked;
        const { filterName, filterValue, filterType, exploreLink } = target.dataset;
        let analyticsParams;
        const formEl = this.el.querySelector("form");
        let filters = this._getFilters(formEl);

        target.classList.toggle(FILTER_ACTIVE_STATE, shouldBeActive);
        filterInputEl.checked = shouldBeActive;

        this._findAndUpdateSelectedFilters(filterName, filterValue);

        if (filterType === "filter") {
            if (!shouldBeActive) {
                this._removeDependentFilters(filterName, filters);
            }
            if (!shouldBeActive && filters[filterName]) {
                filters = this._removeFilterKey(filterName, filterValue, filters);
            }

            analyticsParams = [
                "filter",
                shouldBeActive ? "add_quickfilter" : "remove_quickfilter",
                filterInputEl.name
            ];
        } else if (filterType === "sort") {
            // if we're unsetting, we don't want to inherit the old value
            // and in case the previous one was hidden, it doesn't unset automatically
            // so handle in js :(
            delete filters[filterName];
            if (shouldBeActive) {
                filters[filterName] = filterValue;
            }

            analyticsParams = [
                "sort_by",
                shouldBeActive ? "add_quicksort" : "remove_quicksort",
                filterValue
            ];
        }

        analytics.event(...analyticsParams);

        if (exploreLink) {
            // we've temporarily removed the loading state from normal filters since inconsistent
            // state can lead to a situation where we enter the loading state but never reload the
            // filters to take us out again. this is not a problem with links however, since we go
            // to a new page unconditionally
            this.startLoading();
            globals.window.location = exploreLink;
        } else {
            store.dispatch(setActiveFilters(filters));
        }
    },

    onNextFilterClick() {
        analytics.event("quick_filters_card", "next");
        this._transformFilters(FILTER_SCROLL_AMOUNT);
    },
    onPreviousFilterClick() {
        analytics.event("quick_filters_card", "previous");
        this._transformFilters(FILTER_SCROLL_AMOUNT * -1);
    },
    onFilterItemScroll() {
        this._showOrHideFilterNavigation();
    },
    // Called from mobile-feed-toolbar when toolbar menu pins.
    onToolbarPin() {
        this._showOrHideFilterNavigation();
    },
    _showOrHideFilterNavigation() {
        const filtersBounding = this.el.querySelector(FILTER_ITEMS_SELECTOR);
        const allFilters = filtersBounding.querySelector("fieldset");
        const nextButton = this.el.querySelector(NEXT_SELECTOR);
        const previousButton = this.el.querySelector(PREVIOUS_SELECTOR);
        const allFiltersVisible = allFilters.offsetWidth < filtersBounding.offsetWidth;
        const isBeginningOfScroll = filtersBounding.scrollLeft === 0;
        const isEndOfScroll =
            Math.ceil(filtersBounding.scrollLeft + filtersBounding.offsetWidth) ===
            filtersBounding.scrollWidth;
        if (allFiltersVisible) {
            previousButton.classList.add(buttonDisabledClassName);
            nextButton.classList.add(buttonDisabledClassName);
        } else if (isBeginningOfScroll) {
            previousButton.classList.add(buttonDisabledClassName);
            nextButton.classList.remove(buttonDisabledClassName);
        } else if (isEndOfScroll) {
            previousButton.classList.remove(buttonDisabledClassName);
            nextButton.classList.add(buttonDisabledClassName);
        } else {
            previousButton.classList.remove(buttonDisabledClassName);
            nextButton.classList.remove(buttonDisabledClassName);
        }
    },
    _transformFilters(scrollAmount) {
        if (!this.currentlyScrolling) {
            this.currentlyScrolling = true;
            const filtersBounding = this.el.querySelector(`${FILTER_ITEMS_SELECTOR}`);
            browser.animate(filtersBounding, "scrollLeft", scrollAmount, 300).then(() => {
                // Enable interactions again.
                this.currentlyScrolling = false;
            });
        }
    },

    /**
     * This turns the quick-filters into "loading" mode. There isn't a way out of it, since
     * when the loading is complete, a new product feed is created instead that has a fresh state.
     */
    startLoading() {
        this.el.classList.add(`${componentName}--loading`);
    },

    _generateSelectedFilterKeyFromOption(option) {
        return this._generateSelectedFilterKey(option.name, option.value);
    },
    _generateSelectedFilterKey(filterName, filterValue) {
        return `${filterName}${filterValue}`;
    },
    _isOptionInSelectedFilters(option) {
        return this.selectedFilters.has(this._generateSelectedFilterKeyFromOption(option));
    },
    _orderFiltersBySelectionOrder(options) {
        return options.sort((a, b) => {
            let aOrder = this.selectedFilters.get(this._generateSelectedFilterKeyFromOption(a));
            let bOrder = this.selectedFilters.get(this._generateSelectedFilterKeyFromOption(b));
            if (aOrder < bOrder) {
                return -1;
            }
            if (aOrder > bOrder) {
                return 1;
            }
            return 0;
        });
    },
    _removeOptionFromSelectedFilters(option) {
        this.selectedFilters.delete(this._generateSelectedFilterKeyFromOption(option));
    },
    /**
     * @param {*} option
     * selectedFilters is a Map of 'quickfilter' => 'selectedFilterOrder'
     * The options passed back via the API request are looked up and sorted with this ordering
     */
    _addOptionToSelectedFilters(option) {
        this._addToSelectedFilters(option.name, option.value);
    },
    _addToSelectedFilters(filterName, filterValue) {
        this.selectedFilters.set(
            this._generateSelectedFilterKey(filterName, filterValue),
            this.selectedFiltersOrder++
        );
    },
});

